
import { MapTo } from '@adobe/aem-react-editable-components';
import BrandHero, { BrandHeroEditConfig } from './BrandHero';

export default MapTo('cob-corp-acquisition/components/creditonebank/brand-hero')(BrandHero, BrandHeroEditConfig);